<template>
    <div>
        <v-toolbar class="text-md-center text-sm-center text-sm-center" :clipped-left="$vuetify.breakpoint.lgAndUp" color="primary" dark app fixed>
            <v-toolbar-title>
                <img style="height:26px;" src="/images/logo-inverse.png">
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="text-xs-center">
                <div class=" subheading font-weight-medium "><a style="color:#f7e8ee;text-decoration:none;"  @click="showDialog" onMouseOver="this.style.color='white'" onMouseOut="this.style.color='#f7e8ee'">Security Awareness</a></div>
            </div>
        </v-toolbar>
       
        <v-dialog v-model = "dialog" hide-overlay scrollable width = "800px" >
            <v-card>
                <v-card-title  class=" text-xs-center text-md-center ml-4 py-4 headline" >Security Awareness</v-card-title>
                <v-card-text style="height: 300px;">
                <div justify-center class=" subheading text-xs-left ml-4 mr-4">
                    {{app_name}} does not send requests for Internet Banking Login ID, Password, Credit/ Debit card numbers, Bank account numbers or other sensitive financial information by email.
                </div>
                
                <div justify-center class=" subheading text-xs-left ml-4 mr-4 mt-3">
                  In case of any suspicious activity on your mobile number, you are requested to change your Internet Banking Login ID and Transaction Password.  
                </div>
                
                <div justify-center class=" subheading text-xs-left ml-4 mr-4 mt-3">
                   It is important to use up-to-date Anti-virus software and a personal firewall. {{app_name}} uses a combination of Secure Socket Layer (SSL) protocol and passwords to protect your information.
                </div>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                
                <v-btn color="primary" flat="flat" @click="dialog = false">close</v-btn>
               
                </v-card-actions>
            </v-card>
        </v-dialog>
        
    </div>
</template>

<script>
import global from '@/components/rbconstants';
export default {
    
    data: () => ({
        app_name : global.app_name,
        
        dialog: false
    }),
    
    methods: {
         
        showDialog: function() {
             
            var app = this
            
            app.dialog = true
             
        }
         
    }
   
  }
  
</script>


<style scoped>
    
    #border {
        
        border-radius: 10px;
        border: 1px solid #DADCE0;
        /*border: 2px solid #73AD21;*/
        /*padding: 20px; */
        /*width: 200px;*/
        /*height: 150px;  */
        
    }
    
    .Row
{
    display: table;
    width: 100%; /*Optional*/
    table-layout: fixed; /*Optional*/
    border-spacing: 10px; /*Optional*/
}
.Column
{
    display: table-cell;
    background-color: #EBEED6; /*Optional*/
}
    
    
</style>